import React from "react";
import { NavLink } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">pdf-convert.fr</div>
          <div className="footer-tagline">
            Conversion & compression – 100% dans votre navigateur.
          </div>
        </div>

        <nav className="footer-links" aria-label="Liens légaux">
          <NavLink to="/mentions-legales" className="footer-link">
            Mentions légales
          </NavLink>
          <NavLink to="/confidentialite" className="footer-link">
            Confidentialité
          </NavLink>
          <NavLink to="/conditions" className="footer-link">
            Conditions
          </NavLink>
          <a className="footer-link" href="mailto:contact@pdf-convert.fr">
            Contact
          </a>
        </nav>
      </div>

      <div className="footer-bottom">
        <span>© {year} pdf-convert.fr</span>
        <span className="footer-dot">•</span>
        <span>Fichiers traités localement</span>
      </div>
    </footer>
  );
}
